import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Fetches the list of non-pending vendor invoices
 * @returns {Promise} - API response containing list of non-pending invoices
 */
export const getNonPendingVendorInvoices = async () => {
  try {
    const response = await apiClient.get('/vendorInvoiceManagement/invoice/list-non-pending');

    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
